export default {
    computed: {
        rootUrl() {
            return this.$store.getters.getRootURL
        },
        imagesUrl() {
            return this.$store.getters.getImageURL
        },
        imagesPath() {
            return this.rootUrl + this.imagesUrl
        },
        uploadsUrl() {
            return this.$store.getters.getUploadsURL
        },
        uploadsPath() {
            return this.rootUrl + this.uploadsUrl
        },
    },
}